const state = () => ({
  measurement: null,
})

const getters = {
  measurement: (state) => state.measurement,
}

const mutations = {
  receiveMeasurement(state, measurement) {
    state.measurement = measurement
  },
  clearMeasurement(state) {
    state.measurement = null
  },
}

const actions = {
  getMeasurement({ commit, rootState }, examId) {
    return this.$axios
      .post('/bodygram-backend/v1/app/measurement/get', {
        accessToken: rootState.user.token,
        examId,
      })
      .then((response) => {
        commit('receiveMeasurement', response.data.measurement)
      })
      .catch(() => {
        commit('clearMeasurement')
      })
  },
  createMeasurement({ dispatch, rootState }, measurement) {
    return this.$axios
      .post('/bodygram-backend/v1/app/measurement/create', {
        accessToken: rootState.user.token,
        measurement,
      })
      .then((response) => {
        dispatch('getMeasurement', response.data.measurement.examId)
      })
  },
  updateMeasurement({ dispatch, rootState, rootGetters }, measurement) {
    return this.$axios
      .post('/bodygram-backend/v1/app/measurement/update', {
        accessToken: rootState.user.token,
        measurement,
      })
      .then(() => {
        dispatch('getMeasurement', measurement.examId)
      })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
